var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-breadcrumb',{staticClass:"breadcrumb"},_vm._l((_vm.breadcrumbs),function(route){return _c('a-breadcrumb-item',{key:route.id},[_c('router-link',{attrs:{"to":route.path}},[_vm._v(_vm._s(route.name))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }